



























































import { Vue, Component } from 'vue-property-decorator';
import { Picker, Popup, Toast, Field } from 'vant';
import { rule } from '../submit';
import { field } from '../submit';
import Uploader from '@/components/next/NewUploader.vue';
import { save, getUserList } from '../api';
import { FileType } from '@/common/ts/enum';
import SlideVerify from '@/components/next/SlideVerify.vue';
import { isWeiXin } from '@/common/ts/common';
import { unionIdIsBind } from '@/api/api';
import qs from 'qs';

Vue.use(Picker)
  .use(Popup)
  .use(Toast)
  .use(Field);
@Component({
  components: {
    Uploader,
    SlideVerify,
  },
})
export default class Save extends Vue {
  maxTime = '60秒';
  Video = FileType.Video;
  list = rule;
  field = field;
  showPicker: boolean = false;
  pickerTile = '';
  columns = [];
  value = '';
  imageMaxSize = 10;
  imageMinSize = 0;
  maxImage = 1;
  countyList = [];
  // allow = true;
  unionid: string | null = '';
  typehistory: string = '';
  async mounted() {
    this.unionid = window.localStorage.getItem('unionid');
    const token = window.gettoken();
    if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
    } else if (!token && window.udid) {
      this.AppLogin();
    }
    this.checkIsBind();
    const ret = await getUserList(1, this.unionid);
    if (ret.data.length > 0) {
      this.typehistory = ret.data[0].workType;
    }
  }
  async checkIsBind() {
    const data = {
      type: 2,
      unionId: this.unionid,
    };
    if (window.udid) {
      this.AppLogin();
    } else if (isWeiXin()) {
      const res: any = await unionIdIsBind(data);
      if (!res.data) {
        this.$router.push(
          `/BindPhone?url=${encodeURIComponent(location.href)}`,
        );
        return false;
      } else {
        return true;
      }
    }
  }
  async openPicker(data: any) {
    if (data.value === 'county') {
      this.columns = this.countyList;
    } else {
      this.columns = data.columns;
    }
    this.pickerTile = data.title;
    this.showPicker = true;
    this.value = data.value;
  }
  onConfirm(value: any, index: any) {
    this.showPicker = false;
    this.field[this.value] = value;
  }
  clearData() {}
  onCancel() {
    this.showPicker = false;
  }
  async getCover() {
    this.field.cover = (await (this.$refs
      .uploaderImage as any)[0].uploadToOss()) as string[];
  }
  async submit() {
    // if (!this.allow) {
    //   Toast.fail('请求提交中...');
    //   return false;
    // }
    // this.allow = false;
    // setTimeout(() => {
    //   this.allow = true;
    // }, 2000);
    this.list.map((item: any) => {
      if (item.require && !this.field[item.value]) {
        Toast.fail(item.placeholder);
        throw new Error('错误');
      }
      if (item.reg && !item.reg.test(this.field[item.value])) {
        Toast.fail('电话号码格式错误');
        throw new Error('错误');
      }
      if (item.max) {
        if (this.field[item.value].length > item.max) {
          Toast.fail(item.label + '字数不能超过' + item.max + '个字');
          throw new Error('错误');
        }
      }
    });
    if (this.typehistory && this.typehistory !== this.field.work_type) {
      Toast.fail('请选择首次上传的作品组别');
      return false;
    }
    if (this.field.cover.length === 0) {
      Toast.fail('请点击封面图下方‘上传’按钮');
      return false;
    }
    this.field.udid = window.udid;
    this.field.appkey = window.appkey;
    this.field.unionid = localStorage.getItem('unionid');
    // this.field.unionid = 'oGN7AjkZmK0rKbC6H4O0tsKRMpZU';
    if (this.field.cover.length > 0) {
      if (this.field.cover instanceof Array) {
        this.field.cover = this.field.cover.join('|');
      }
    }
    this.fSlideData();
  }
  async fSlideData() {
    // this.showSlideVerify = false;
    // const lastData = Object.assign(res, this.field);
    const ret: any = await save(this.field);
    console.log('ret:::::', ret);
    if (ret.code === 200) {
      Toast.success(ret.msg);
      this.field.name = '';
      this.field.work_type = '';
      this.field.author_name = '';
      this.field.phone = '';
      this.field.sch_name = '';
      this.field.teacher_name = '';
      this.field.introduction = '';
      this.field.cover = [];
      setTimeout(() => {
        // this.$router.go(0);
      }, 2000);
      this.$router.push('user');
    } else {
      Toast.fail(ret.msg);
    }
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }

  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
}
